import { render, staticRenderFns } from "./PageSettings.vue?vue&type=template&id=c01dd956&scoped=true&lang=pug&"
import script from "./PageSettings.vue?vue&type=script&lang=js&"
export * from "./PageSettings.vue?vue&type=script&lang=js&"
import style0 from "./PageSettings.vue?vue&type=style&index=0&id=c01dd956&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c01dd956",
  null
  
)

export default component.exports